import Cookies from "js-cookie";
import merge from "lodash/merge";
import { Auth } from "aws-amplify";
import { configureRefreshFetch, fetchJSON } from "refresh-fetch";

import { FetchError } from "../types/APIResponseType";
import { setSession } from "../redux/reducers/session";
import { store } from "../redux";

const COOKIE_NAME = "ACCESS_TOKEN";

type FetchOptions = Record<string, any>;

const retrieveToken = () => Cookies.get(COOKIE_NAME);
const saveToken = (token: string) => Cookies.set(COOKIE_NAME, token);
const clearToken = () => Cookies.remove(COOKIE_NAME);

const fetchJSONWithToken = (url: string, options: FetchOptions = {}) => {
  const token = retrieveToken();

  let optionsWithToken = options;
  if (token != null) {
    optionsWithToken = merge({}, options, {
      headers: options?.headers
        ? new Headers({
            ...options.headers,
            Authorization: `Bearer ${retrieveToken()}`,
          })
        : {},
    });
  }
  return fetchJSON(url, optionsWithToken);
};

const shouldRefreshToken = (error: FetchError) => {
  return (
    error.response.status === 401 && error.body.includes("Authorization header contains a JWT token that expired at")
  );
};

// Do the actual token refreshing and update the saved token
const refreshToken = async () => {
  try {
    // eslint-disable-next-line no-console
    console.log("Refreshing the token...");
    const user = await Auth.currentSession();
    const newSession = {
      accessToken: user.getAccessToken().getJwtToken(),
      idToken: user.getIdToken().getJwtToken(),
      refreshToken: user.getRefreshToken().getToken(),
    };
    await store.dispatch(setSession(newSession));
    saveToken(newSession.accessToken);
  } catch (error) {
    setSession({
      accessToken: "",
      idToken: "",
      refreshToken: "",
    });
    clearToken();
    throw error;
  }
};

export const configuredFetch = configureRefreshFetch({
  // Pass fetch function you want to wrap, it should already be adding
  // token to the request
  fetch: fetchJSONWithToken,
  // shouldRefreshToken is called when API fetch fails and it should decide
  // whether the response error means we need to refresh token
  shouldRefreshToken,
  // refreshToken should call the refresh token API, save the refreshed
  // token and return promise -- resolving it when everything goes fine,
  // rejecting it when refreshing fails for some reason
  refreshToken,
});
